import type { FC } from "react";
import person from "../assets/person.png";
import { useWidget } from "../contexts/useWidget";

/**
 * Brand mascot avatar shown in welcome chrome (landing + custom main page).
 * Decorative halo circles use `text-lastbot-avatar-highlight` so embedder
 * CSS-var overrides tint them via fill="currentColor".
 */
const BrandAvatar: FC = () => {
  const { brandInformation } = useWidget();

  return (
    <div
      className="relative m-2 text-lastbot-avatar-highlight"
      data-testid="brand-avatar"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 100"
        className="absolute z-1 -bottom-1 -left-3 size-32 opacity-25"
        fill="currentColor"
      >
        <circle cx="50" cy="50" r="50" />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 100"
        className="absolute z-2 -top-2 -left-2 size-32"
        fill="currentColor"
      >
        <circle cx="50" cy="50" r="50" />
      </svg>
      <div className="relative z-3">
        <div className="rounded-full size-32 overflow-hidden relative z-1 bg-lastbot-avatar-highlight/50">
          <img
            src={brandInformation.avatar || person}
            alt="Avatar"
            className="absolute inset-0 w-full h-full"
          />
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 100 100"
          className="absolute bottom-1 right-4 z-2 size-5"
          data-testid="brand-avatar-online-indicator"
        >
          <circle cx="50" cy="50" r="50" fill="#FFFFFF" />
          <circle cx="50" cy="50" r="42" fill="#12B76A" />
        </svg>
      </div>
    </div>
  );
};

export default BrandAvatar;
